// extracted by mini-css-extract-plugin
export default {"container":"ShapePanel_container__V66Al","icon":"ShapePanel_icon__3dI7Z","selected":"ShapePanel_selected__YGInA"};